export function validatePromotionCodeFormat(raw: string): string | undefined {
  const t = raw.trim();
  if (t.length === 0) {
    return undefined;
  }
  if (t.length < 4) {
    return 'Promotion code must be at least 4 characters';
  }
  if (t.length > 15) {
    return 'Promotion code cannot exceed 15 characters';
  }
  if (!/^[a-zA-Z0-9]+$/.test(t)) {
    return 'Promotion code must contain only letters and numbers';
  }
  return undefined;
}